import { put, takeLatest, call } from 'redux-saga/effects';
import * as ordersService from '../../../services/orderService';
import {
  GET_PAST_USERS_ORDERS_OF_VENUE,
  GET_PAST_USERS_ORDERS_OF_VENUE_SUCCESS,
  GET_PAST_USERS_ORDERS_OF_VENUE_ERROR,
} from '../../actions/order';
function* getPastUsersOrdersOfVenueSaga(action) {
  try {
    const data = yield call(
      ordersService.GetPastUsersOrdersOfVenue,
      action.payload
    );
    yield put({
      type: GET_PAST_USERS_ORDERS_OF_VENUE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: GET_PAST_USERS_ORDERS_OF_VENUE_ERROR,
      error: error.data,
    });
  }
}

export function* getPastUsersOrdersVenueSagaWatcher() {
  yield takeLatest(
    GET_PAST_USERS_ORDERS_OF_VENUE,
    getPastUsersOrdersOfVenueSaga
  );
}
